<script>
  import { layoutMethods, peddlrWalletKycLiteMethods, peddlrWalletKycLiteComputed, customerListLiteComputed} from "@/state/helpers";
  import profileKycActivityLog from "@/views/pages/_version_2_/peddlr-lite/merchant/profileInformation/profileKycActivityLog.vue";


  /**
   * Profile KYC Details component
   */
  export default {
    page: {
      title: "Profile KYC Details"
    },
    components: {
      profileKycActivityLog
    },
    computed: {
      ...peddlrWalletKycLiteComputed,
      ...customerListLiteComputed
    },
    data() {
      return {
        title: "Profile KYC Details",
        testbtn:false,
        isDisplayed: true,
        searchValue: {
          dateRange: null,
          sort: 'id',
          orderDesc: true,
          page: 1,
          rows: 10,
        },
        sortBy: "value",
        sortDesc: false,
        rangeOptions: {
          mode: "range",
        },
        fields: [
          {key: "modifiedBy", sortable: true},
          {key: "modifiedAt", sortable: true, label: 'Modified Date & Time'},
          {key: "verifiedAt", sortable: true, label: 'Date Verified'},
          {key: "uploadedSelfie", sortable: true},
          {key: "livelinessCheck", sortable: true},
          {key: "uploadedId", sortable: true},
          {key: "signature", sortable: true, label:"Signature or Biometrics"},
          {key: "kycAcctType", sortable: true, label:"KYC Account Type"},
          {key: "kycAcctStatus", sortable: true, label:"KYC Account Status"},
          {key: "remarks", sortable: true},
        ],
        businessId: 0,
        infoType  : null,
        kycWord:{
          "NoKYC" : "Don't Have KYC",
          "PendingKYC" : "Don't Have KYC",
          "FailedKYC" : "Failed KYC",
          "FullyVerified" : "Fully Verified",
        }
      };
    },
    methods: {
      ...layoutMethods,
      ...peddlrWalletKycLiteMethods,
      changeDisplayStatus (){
        this.isDisplayed = !this.isDisplayed
      },
      openModal(modal=''){
        this.$bvModal.show(modal);
      },
      closeModal(modal=''){
        this.$bvModal.hide(modal);
      },
      async onSearch(state = ''){
          console.log("onsearch");
          if(state == 'reset'){
            this.searchValue.page = 1;
          }
      },
      onExport(){

      },
      tableSort(ctx){//context
        this.searchValue.sort = ctx.sortBy;
        this.searchValue.orderDesc = ctx.sortDesc;
        console.log(">> sorting...",ctx);
        this.onSearch('reset');
      },
      async fetchUserKycStatus(){
        // console.log(">>> trigger: ",this.businessDetails.subscriberId);
        await this.getUserKycStatus({userId: this.businessDetails.subscriberId});
      },
      async test(params){
        await this.testUserKycStatus(params);
      }
    },
    async mounted(){
      this.businessId = this.$route.params.bid
      this.infoType = this.$route.params.tab;
      // console.log(">>> mounted: ",this.businessDetails.subscriberId);
      // await this.fetchUserKycStatus();
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
    <div class="card">
      <b-card-header header-tag="header" role="tab" class="pb-0">
        <button v-if="testbtn" @click="test({kycAcctType:'Fully Verified', kycAcctStatus: 'live', kycStatus: 'verified'})">Fully Verified l</button>
        <button v-if="testbtn" @click="test({kycAcctType:'Fully Verified', kycAcctStatus: 'freeze', kycStatus: 'verified'})">Fully Verified f</button>
        <button v-if="testbtn" @click="test({kycAcctType:'Failed KYC', kycAcctStatus: 'failed verification', kycStatus: 'failed'})">Failed KYC</button>
        <button v-if="testbtn" @click="test({kycAcctType:'Don\'t have KYC', kycAcctStatus: 'pending verification', kycStatus: 'pending'})">Pending KYC</button>
        <button v-if="testbtn" @click="test({kycAcctType:'Don\'t have KYC', kycAcctStatus: null, kycStatus: null})">Don't have KYC</button>
        <h6 class="m-0">
          <span @click="fetchUserKycStatus">KYC Details</span>
          <!-- <a
            v-b-toggle.accordion-1
            class="text-primary float-end"
            href="javascript: void(0);"
            @click="changeDisplayStatus"
            >
            <span v-if="isDisplayed">
              Hide <feather type="chevron-up"></feather>
            </span>
            <span v-else>
              Show <feather type="chevron-down"></feather>
            </span>
          </a> -->
          <!-- <div class="float-end me-3 font-size-18 d-flex justify-content-center justify-content-lg-end">
            <span class="badge rounded-pill bg-success"><i class="bx bxs-badge-check"></i> Fully Verified</span>
            <span class="badge rounded-pill bg-warning"><i class="bx bxs-timer"></i> Pending KYC</span>
            <span class="badge rounded-pill bg-danger"><i class="bx bxs-user-x"></i> Failed KYC</span>
          </div>  -->
          <div class="float-end font-size-16 d-flex justify-content-center align-items-center">
            <!-- <p class="text-success" v-if="userKycStatus.kycStatus == 'verified'">
              <span class="me-1"><i class="bx bxs-badge-check"></i></span> 
              <span>{{userKycStatus.kycAcctType}}</span>
            </p>
            <p class="text-warning" v-else-if="userKycStatus.kycStatus == 'pending'">
              <span class="me-1"><i class="bx bxs-timer"></i></span> 
              <span>{{userKycStatus.kycAcctType}}</span>
            </p>
            <p class="text-danger" v-else-if="userKycStatus.kycStatus == 'failed'">
              <span class="me-1"><i class="bx bxs-user-x"></i></span> 
              <span>{{userKycStatus.kycAcctType}}</span>
            </p>
            <p v-else>{{userKycStatus.kycAcctType}}</p> -->
            <p class="font-size-18">
              <span class="badge rounded-pill me-1"
                :class="{
                      'bg-success'  : userKycStatus.kycStatus == 'verified',
                      'bg-danger'   : userKycStatus.kycStatus == 'failed',
                      'bg-light'    : userKycStatus.kycStatus == null || userKycStatus.kycStatus == 'pending'
                      }">
                <i class="bx"
                  :class="{
                    'bxs-badge-check' : userKycStatus.kycStatus == 'verified',
                    'bxs-user-x'      : userKycStatus.kycStatus == 'failed',
                    'bx-window-close' : userKycStatus.kycStatus == null || userKycStatus.kycStatus == 'pending'
                    }"
                ></i> 
                {{kycWord[userKycStatus.kycAcctType]}}
              </span> 
              <span class="text-disabled" v-if="userKycStatus.kycAcctStatus != null">|</span>
              <small class="text-capitalize" v-if="userKycStatus.kycStatus != null"
                :class="{
                      'text-success'  : userKycStatus.kycStatus == 'verified' && userKycStatus.kycAcctStatus == 'Live',
                      'text-muted'    : userKycStatus.kycStatus == 'verified' && userKycStatus.kycAcctStatus == 'Freeze',
                      'text-pending'  : userKycStatus.kycStatus == 'pending',
                      'text-danger'   : userKycStatus.kycStatus == 'failed'
                      }">
                {{ userKycStatus.kycAcctStatus | formatKycAccountStatus }}
              </small>
            </p>
          </div> 
        </h6>
      </b-card-header>
      <div v-if="userKycStatus.kycAcctType != 'NoKYC'">
      <!-- <div> -->
        <b-card-body class="p-0">
          <router-link :to="{ name: 'Lite Profile Information Kyc', params: { tab: infoType, bid: businessId, wallet: 'e-load' }}">
            <button class="btn btn-primary float-end m-3">View Details</button>
          </router-link>
          <b-card-text class="p-4">
            <div>
              <span class="fw-semibold me-2">Activity Logs:</span>
              <b-link class="small fw-semibold" @click="openModal('bv-modal-kyc-activity-log')">View</b-link>
            </div>
          </b-card-text>
        </b-card-body>
      </div>
    </div>


    <!-- MODAL -->
    <b-modal id="bv-modal-kyc-activity-log" title="Reason Log" size="lg" 
             centered hide-header hide-title hide-footer hide-header-close no-close-on-backdrop>
      
      <profile-kyc-activity-log/>
      
      <div class="text-end mt-3 mb-1">
        <b-button class="w-sm"
                  type="button"
                  variant="light"
                  @click="closeModal('bv-modal-kyc-activity-log')"
                  >Close
        </b-button>
      </div>
    </b-modal><!--bv-modal-kyc-activity-log-->
  </div> <!-- end of outer div-->
</template>

<style>
.text-pending{
  color: #DC7512;
}
.text-disabled{
  color: #ccc;
}
.text-danger{
  color: #9A211F;
}
.text-success{
  color: #508F30;
}
</style>